// Key predates the move into the Timeline store; kept so existing preferences carry over.
const TIMELINE_ROUTE_STATS_SETTING_LOCAL_STORAGE_KEY = 'routeStatsIsExpanded';

const getTimelineRouteStatsPreference = (): boolean => {
  try {
    const preferenceJson = localStorage.getItem(TIMELINE_ROUTE_STATS_SETTING_LOCAL_STORAGE_KEY);
    // Default to expanded (stats visible) when no preference has been saved yet.
    return preferenceJson ? !!JSON.parse(preferenceJson) : true;
  } catch {
    return true;
  }
};

const setTimelineRouteStatsPreference = (statsExpanded: boolean) => {
  try {
    localStorage.setItem(TIMELINE_ROUTE_STATS_SETTING_LOCAL_STORAGE_KEY, JSON.stringify(statsExpanded));
  } catch {
    // Persisting the preference is best-effort; ignore storage failures
    // (e.g. private mode / quota exceeded) so the toggle still works.
  }
};

export {
  getTimelineRouteStatsPreference,
  setTimelineRouteStatsPreference,
  TIMELINE_ROUTE_STATS_SETTING_LOCAL_STORAGE_KEY,
};
